import { paginate } from './_Utils';

/* eslint-disable */
const setGages = () => {
    const gauge1 = new JustGage({
        id: 'gauge1',
        min: 0,
        max: 100,
        title: '',
        label: 'Mbps',
        relativeGaugeSize: true,
        counter: true,
        levelColors: ['#ff4a72'],
    });

    const gauge3 = new JustGage({
        id: 'gauge3',
        value: 3,
        min: 0,
        max: 25,
        title: '',
        label: 'Mbps',
        counter: true,
        levelColors: ['#29c1e6'],
    });

    const gauge10 = new JustGage({
        id: 'gauge10',
        value: 10,
        min: 0,
        max: 25,
        title: '',
        label: 'Mbps',
        counter: true,
        levelColors: ['#29c1e6'],
    });

    const gauge25 = new JustGage({
        id: 'gauge25',
        value: 25,
        min: 0,
        max: 25,
        title: '',
        label: 'Mbps',
        counter: true,
        levelColors: ['#29c1e6'],
    });
};
/* eslint-enable */

function init() {
    $(window).on('load', () => {
        setGages();
    });

    paginate($('.providers-wrapper'), $('.provider-card'), 5, true);
}

export { init };
